import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { PublishTaxRulesMutation } from '@/lib/gql/__generated__/canonical-documents';
import type { PublishTaxRulesInput, PublishTaxRulesMutationMutation } from '@/lib/gql/__generated__/graphql';

export const publishTaxRulesActor = fromPromise<PublishTaxRulesMutationMutation, PublishTaxRulesInput>(
  async ({ input }) => {
    const result = await apolloClient.mutate({
      mutation: PublishTaxRulesMutation,
      variables: {
        input: {
          taxRuleSetId: input.taxRuleSetId,
          taxYear: input.taxYear,
          ruleVersion: input.ruleVersion,
        },
      },
    });
    const data = result.data;
    const response = data?.publishTaxRules;
    if (!data || !response?.success) throw new Error(response?.error?.message ?? 'Tax rules could not be published.');
    return data;
  },
);
